import { forwardRef } from "react";
import Text from "../text";
import { jsx as _jsx } from "react/jsx-runtime";
export const Paragraph = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(Text, {
  as: "p",
  ref: ref,
  ...props
}));
export default Paragraph;